module.exports = __webpack_public_path__ + "img/pda.948d4495.svg";